module.exports = __webpack_public_path__ + "static/media/Big-Boost-Two-Lines-BG-Pattern-800x480.f5d1679a.png";